var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataGraphs = function SvgDataGraphs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m9.325 7.033-5.227 5.228m14.915-3.665L12.924 6.98m14.014-2.854-4.667 3.65M1.333 30.666h29.334M9.156 6.223a1.956 1.956 0 1 0 3.91 0 1.956 1.956 0 0 0-3.91 0m17.6-2.933a1.955 1.955 0 1 0 3.91 0 1.955 1.955 0 0 0-3.91 0m-7.823 5.867a1.956 1.956 0 1 0 3.912 0 1.956 1.956 0 0 0-3.912 0m-17.6 4.888a1.956 1.956 0 1 0 3.912 0 1.956 1.956 0 0 0-3.912 0m6.845 9.45H4.267a.99.99 0 0 0-.978.979v6.192h5.867v-6.192a.98.98 0 0 0-.978-.978m9.778-9.122h-3.911a.99.99 0 0 0-.978.978v15.318h5.866V15.35a.98.98 0 0 0-.977-.978m9.777 5.212h-3.91a.99.99 0 0 0-.979.978v10.103h5.867V20.562a.98.98 0 0 0-.978-.978",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgDataGraphs;